export enum FORTER_AUTHORIZATION_STEP {
    PRE_AUTHORIZATION = 'PRE_AUTHORIZATION',
}
